import { createContext, useContext } from "react";
import { UseOrdersReturnType } from "./orders-hooks";

export const OrdersContext = createContext<UseOrdersReturnType | null>(null);
export const useOrdersContext = () => {
  const value = useContext(OrdersContext);
  return value;
};
